import React from 'react'
import "./modal.scss"

const Modal = ({message,setmodalOpen}) => {
    return (
        <section className='modal flex-center' onClick={()=>setmodalOpen(false)}>
            <div className="modal-content flex">
                <aside className='flex-center'>
                    <img src="/images/thumbs2.jfif" alt="thumbs up" />
                </aside>
                <aside className='flex-col bold'>
                <p className='bold'> Hi there, thanks for reaching out, will get back to you soon enough...</p>
                <button onClick={()=>setmodalOpen(false)}> Okay </button>
                </aside>
            </div>
        </section>
    )
}
export default Modal
